import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert, CircularProgress } from '@mui/material';
import { CDN } from './api';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const result = await login(username, password);
    if (result.success) {
      navigate(from, { replace: true });
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#0d0d0d',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 420,
          backgroundColor: '#161616',
          border: '1px solid #2a2a2a',
          borderRadius: 3,
          p: { xs: 3, sm: 5 },
        }}
      >
        {/* Logo */}
        <Box display="flex" justifyContent="center" mb={4}>
          <img
            src={`${CDN}/site/logo.PNG`}
            alt="Emerich Custom Build"
            style={{ height: 64, objectFit: 'contain' }}
          />
        </Box>

        <Typography variant="h6" fontWeight={600} mb={0.5} textAlign="center">
          Admin Portal
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center" mb={4}>
          Emerich Custom Build
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            fullWidth
            autoComplete="username"
            size="medium"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            fullWidth
            autoComplete="current-password"
          />
          <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={loading}
            fullWidth
            sx={{
              mt: 1,
              py: 1.5,
              fontWeight: 600,
              backgroundColor: '#FFA13C',
              color: '#000',
              '&:hover': { backgroundColor: '#e8912e' },
            }}
          >
            {loading ? <CircularProgress size={22} sx={{ color: '#000' }} /> : 'Sign In'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
